import { TextBadgeColor } from "@bps/fluent-ui";

const softwareTypeBadgeColorMap: Record<string, TextBadgeColor> = {
  bundle: TextBadgeColor.grey,
  file: TextBadgeColor.lightGrey,
  application: TextBadgeColor.red,
  dependency: TextBadgeColor.yellow,
  module: TextBadgeColor.green,
  service: TextBadgeColor.blue
};

export const getTypeBadgeColor = (type: string | undefined): TextBadgeColor => {
  if (!type) {
    return TextBadgeColor.lightGrey;
  }

  const normalizedType = type.trim().toLowerCase();
  return softwareTypeBadgeColorMap[normalizedType] ?? TextBadgeColor.lightGrey;
};
